/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AcknowledgeRiskPolicyChallengeRequestBody,
  AcknowledgeRiskPolicyChallengeRequestBody$Outbound,
  AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema,
} from "../components/acknowledgeriskpolicychallengerequestbody.js";

export type GetRiskPolicyChallengeSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetRiskPolicyChallengeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  acknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody;
};

/** @internal */
export type GetRiskPolicyChallengeSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetRiskPolicyChallengeSecurity$outboundSchema: z.ZodMiniType<
  GetRiskPolicyChallengeSecurity$Outbound,
  GetRiskPolicyChallengeSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskPolicyChallengeSecurityToJSON(
  getRiskPolicyChallengeSecurity: GetRiskPolicyChallengeSecurity,
): string {
  return JSON.stringify(
    GetRiskPolicyChallengeSecurity$outboundSchema.parse(
      getRiskPolicyChallengeSecurity,
    ),
  );
}

/** @internal */
export type GetRiskPolicyChallengeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AcknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody$Outbound;
};

/** @internal */
export const GetRiskPolicyChallengeRequest$outboundSchema: z.ZodMiniType<
  GetRiskPolicyChallengeRequest$Outbound,
  GetRiskPolicyChallengeRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    acknowledgeRiskPolicyChallengeRequestBody:
      AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      acknowledgeRiskPolicyChallengeRequestBody:
        "AcknowledgeRiskPolicyChallengeRequestBody",
    });
  }),
);

export function getRiskPolicyChallengeRequestToJSON(
  getRiskPolicyChallengeRequest: GetRiskPolicyChallengeRequest,
): string {
  return JSON.stringify(
    GetRiskPolicyChallengeRequest$outboundSchema.parse(
      getRiskPolicyChallengeRequest,
    ),
  );
}
